/**
 * Created by joaomeireles on 19/10/2017.
 */

window.workflowService = {

    action: null,
    callback: null,
    wfWorkflowParams: null,
    wfWorkflowParamsUrl: null,
    wfWorkflowParamsCallback: null,

    executeServiceFactory: function (action) {

        //in future, filter by software and institution defined in json on table wf_workflow_action

        this.wfWorkflowParams = $.parseJSON(action.wf_action_params);
        this.wfWorkflowParamsUrl = this.wfWorkflowParams[0].url;
        this.wfWorkflowParamsCallback = this.wfWorkflowParams[0].callback;

        switch (this.wfWorkflowParams[0].action_type) {

            case globalConstants.WF_ACTION_TYPE_LOAD_MODAL:
                workflowService.loadModalService(action);

        }

    },

    loadModalService: function (action) {

        debug.log("loadModalService", action.wf_id == parseInt(globalConstants.WF_SMAP_CONSULT) && (action.from_state_id == 6 || action.from_state_id == 14));
        debug.log("callback", this.wfWorkflowParamsCallback);
        debug.log("url", this.wfWorkflowParamsUrl);

        // SMAP FINALZED
        if (action.wf_id == parseInt(globalConstants.WF_SMAP_CONSULT) && (action.from_state_id == 6 || action.from_state_id == 14)){
            debug.log("entrei!");
            workflowService.executeDischargeModalService(action);
        }

    },

    executeDischargeModalService: function (action) {

/*      debug.log("finalizedDischargeModal action", action);
        debug.log("finalizedDischargeModal params", params);
        debug.log("finalizedDischargeModal wfWorkflowParams", action.wf_action_params);
        debug.log("finalizedDischargeModal url", this.wfWorkflowParams[0].url);*/
        debug.log("executeDischargeModalService", this.wfWorkflowParamsUrl);

         var params = {task_id:action.task_id,
         wf_id:action.wf_id,
         wf_status_id:action.to_state_id,
         wf_action_id:action.wf_action_id};

         $.get(this.wfWorkflowParamsUrl, params, null, "html")
         .done(function (data, status, xhr) {
         Hades.checkIfUserIsAuthorized(data, status, xhr);

         $.fancybox({content:data, autoScale:true, autoDimensions:true});

         $('#smap-finalized-consult-modal-ct').bind('SmapFinalizedConsultModalConfirmed', episode.FinalizeSmapConsult);

         Hades.hideLoading();
         })
         .fail(function (xhr, status, error) {
         Hades.showError(error, xhr.responseText, xhr, status, error);
         Hades.hideLoading();
         });

    },
}




